import { Component } from "react"
import PropTypes from "prop-types"

import colors from "foundation/_colors_export.scss?variables"
import EmptyStateComponent from "../shared/empty_state_component"
import chevronLeftBlack from "images/layout/chevron-right-black.svg"

export default class MyServices extends Component {
  render() {
    return this.props.services.length ? (
      <>
        <h1>My services</h1>

        <hr />

        <ul className="services-list">
          {this.props.services.map((service_raw, idx) => {
            const service = service_raw.channel

            return (
              <li className="service-item" key={idx}>
                <a
                  href={`/${service.module_name}`}
                  data-track-ifttt-next-event="click"
                  data-track-data={JSON.stringify({
                    object_type: `service`,
                    object_id: service.module_name,
                    location_type: "my_services",
                  })}
                >
                  <img
                    src={service.lrg_monochrome_image_url}
                    title={service.name}
                    alt={service.name}
                    className="service-icon"
                    loading="lazy"
                    width="63"
                    height="63"
                  />
                  <h2 className="service-title">{service.name}</h2>
                  <span
                    className="service-arrow"
                    dangerouslySetInnerHTML={{
                      __html: chevronLeftBlack,
                    }}
                  />
                </a>
              </li>
            )
          })}
        </ul>
      </>
    ) : (
      <EmptyStateComponent
        buttonColor={colors.primaryTextColor}
        buttonLink={this.props.discoverPath}
        heroImages={this.props.heroImages}
      />
    )
  }
}

MyServices.propTypes = {
  services: PropTypes.arrayOf(
    PropTypes.shape({
      channel: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }),
    })
  ),
  heroImages: PropTypes.arrayOf(PropTypes.string).isRequired,
  discoverPath: PropTypes.string.isRequired,
}
